/**
 * TanStack Query hooks for `rest-json-api-format`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	restJsonApiFormatQueryKeys,
	type CreateRestJsonApiFormatBody,
	type ListRestJsonApiFormatResponse,
	type RestJsonApiFormatRow,
} from "./api";

export function useRestJsonApiFormatList(): UseQueryResult<ListRestJsonApiFormatResponse, Error> {
	return useQuery({
		queryKey: restJsonApiFormatQueryKeys.list(),
		queryFn: list,
	});
}

export function useRestJsonApiFormatCreate(): UseMutationResult<RestJsonApiFormatRow, Error, CreateRestJsonApiFormatBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: restJsonApiFormatQueryKeys.all });
		},
	});
}

export function useRestJsonApiFormatDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: restJsonApiFormatQueryKeys.all });
		},
	});
}
